// Use for re-throwing an error that is handled, but not part of the handling logic.
// Helps avoid a linter error also
export function throwError(error) {
  throw error;
}

export const executeOnce = (func) => {
  let alreadyCalled = false;
  let result;
  return (...args) => {
    if (!alreadyCalled) {
      result = func.apply(this, args);
      alreadyCalled = true;
    }
    return result;
  };
};

const captureIndexKey = new Set();
/**
 * @function executeOnceForKey Ensures function is only executed once per unique key
 * @param  {String} indexKey key to index the execution of the function
 * @param  {Function} func
 */
export const executeOnceForKey = (indexKey, func) => {
  if (captureIndexKey.has(indexKey)) return;
  captureIndexKey.add(indexKey);
  func();
};
